import type { DetailedHTMLProps, MetaHTMLAttributes } from "react"

type Arg = {
  title?: string
  description?: string
  socialTitle?: string
  socialDescription?: string
}

/**
 * Page meta tags for a site: the title is suffixed with the site name unless
 * it already starts with it, and social tags fall back to the page's own.
 */
export const createMeta =
  (siteName: string) =>
  ({ title, description, socialTitle, socialDescription }: Arg) => {
    const items: DetailedHTMLProps<
      MetaHTMLAttributes<HTMLMetaElement>,
      HTMLMetaElement
    >[] = []
    const ogTitle = socialTitle ?? title
    const ogDescription = socialDescription ?? description

    if (title) {
      items.push({
        title: title.startsWith(siteName) ? title : `${title} – ${siteName}`,
      })
    }
    if (description) {
      items.push({ name: "description", content: description })
    }
    if (ogTitle) {
      items.push({ property: "og:title", content: ogTitle })
    }
    if (ogDescription) {
      items.push({ property: "og:description", content: ogDescription })
    }
    if (ogTitle) {
      items.push({ name: "twitter:title", content: ogTitle })
    }
    if (ogDescription) {
      items.push({ name: "twitter:description", content: ogDescription })
    }

    return items
  }
